import { useContext } from 'react';

import { configContext } from '../config-context';

// Backwards compatibility to ensure 'Locale' still functions before doing a refactor.
export const useLocale = () => {
  const { site } = useConfig();
  switch (site) {
    case 'employer-seek-nz':
      return 'NZ';
    default:
      return 'AU';
  }
};

export const useSite = () => {
  const { site } = useConfig();
  return site;
};

export const useLanguage = () => {
  const { language } = useConfig();
  return language;
};

/**
 * Returns true if the local is AU or NZ
 */
export const useIsAuNz = () => {
  const { locale } = useConfig();
  return locale.match(/AU|NZ/);
};

export const useConfig = () => {
  const config = useContext(configContext);
  if (!config) {
    throw new Error('useConfig must be used within a ConfigProvider');
  }
  return config;
};
